import { Checkpoint } from "components";
import { ICheckPoint } from "interfaces/product-cta-interface";

export const ProductCustomCheckpoints = ({
  items,
  color,
}: {
  items: ICheckPoint[];
  color;
}) => {
  return (
    <>
      {items.map((item: ICheckPoint, index: number) => (
        <Checkpoint label={item.checkpoint} color={color} key={index} />
      ))}
    </>
  );
};
